import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPromotionalCodeState, IPromotionalCodeDiscount, IVerifyPromotionalCodeData } from './interfaces';
import { verifyPromotionalCode } from './thunk';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

const initialState: IPromotionalCodeState = {
  validating: false,
  discount: undefined,
  code: undefined,
  error: undefined
};

const promotionalCodeSlice = createSlice({
  name: 'promotionalCode',
  initialState,
  reducers: {
    resetState: (state: IPromotionalCodeState) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.validating = false;
      state.discount = undefined;
      state.code = undefined;
      state.error = undefined;
    }
  },
  extraReducers: {
    [verifyPromotionalCode.pending.type]: (state: IPromotionalCodeState) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.validating = true;
      state.discount = undefined;
      state.code = undefined;
      state.error = undefined;
    },
    [verifyPromotionalCode.fulfilled.type]: (state: IPromotionalCodeState, action: PayloadAction<IPromotionalCodeDiscount, string, { arg: IVerifyPromotionalCodeData }>) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      const { meta: { arg: { code } } } = action;
      state.validating = false;
      state.discount = action.payload;
      state.code = code;
    },
    [verifyPromotionalCode.rejected.type]: (state: IPromotionalCodeState, action: PayloadAction<string>) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.validating = false;
      state.discount = undefined;
      state.code = undefined;
      state.error = action.payload;
    }
  }
});

const { resetState } = promotionalCodeSlice.actions;
export const actions = {
  resetState
};

export const PromotionalCodeReducer = promotionalCodeSlice.reducer;